import React, { useEffect, useState } from 'react';
import { auth } from '../_actions/user_actions';
import { useSelector, useDispatch } from "react-redux";
import NavBar from '../components/views/NavBar/NavBar';
import TabBar from '../components/views/NavBar/TabBar';

export default function (ComposedClass, reload, isRoot = false, adminRoute = false, noCheck = false) {

    function AuthenticationCheck(props) {

        let userInRedux = useSelector(state => state.user);
        const dispatch = useDispatch();

        const [User, setUser] = useState();

        useEffect(() => {
            setUser(userInRedux);
        }, [userInRedux]);

        useEffect(() => {

            if (noCheck) return;

            dispatch(auth()).then(async response => {
                if (await !response.payload.isAuth) {
                    console.log('인증 안됐네');
                    if (reload) {
                        console.log('로그인부터 하자');
                        props.history.push('/login')
                    }
                } else {
                    if (adminRoute && !response.payload.isAdmin) {
                        console.log('관리자외 출입금지');
                        props.history.push('/')
                    }
                    else {
                        if (reload === false) {
                            props.history.push('/')
                        }
                    }
                }
            })

        }, [dispatch, props.history, userInRedux.googleAuth])

        return (
            <>
                <NavBar {...props} isRoot={isRoot} />
                <ComposedClass {...props} user={User} />
                {isRoot && <TabBar />}
            </>
        )
    }

    return AuthenticationCheck
}


